import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from '@bingads-webui-campaign-react/router';
import { getLevel, setLevel, TargetingLevel } from '@bingads-webui-campaign/targeting-settings-scaffolds';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { navigateToTargetLevel } from './utils';

export const ShellCtor = (urls, levelSelector) => class Shell extends React.PureComponent {
  static propTypes = {
    scope: PropTypes.shape({
      values: {
        adGroupId: PropTypes.number,
        campaignId: PropTypes.number,
      },
    }),
    component: PropTypes.elementType.isRequired,
    perfMarker: perfMarkerPropTypes.isRequired,
  }

  static defaultProps = {
    scope: {},
  }

  render() {
    return (
      <Switch>
        <Route
          exact
          path={urls[2]}
          render={() => {
            const {
              scope,
            } = this.props;
            const level = getLevel(scope.values.adGroupId, true);
            navigateToTargetLevel(level, scope, urls, true);
          }}
        />
        <Route
          exact
          path={urls[0]}
          render={() => {
            const {
              scope,
              component,
            } = this.props;
            if (scope.values.adGroupId > 0) {
              // go to an ad group at campaign level
              setLevel(TargetingLevel.AdGroup, true);
              navigateToTargetLevel(TargetingLevel.AdGroup, scope, urls);
              return;
            }
            const LevelSelector = levelSelector;
            setLevel(TargetingLevel.Campaign, true);
            // eslint-disable-next-line consistent-return
            return (
              <LevelSelector component={component} {...this.props} urls={urls} perfMarker={this.props.perfMarker.createChild('campaign_scope_page')} />
            );
          }}
        />
        <Route
          exact
          path={urls[1]}
          render={() => {
            const {
              component,
            } = this.props;
            const LevelSelector = levelSelector;
            setLevel(TargetingLevel.AdGroup, true);
            // eslint-disable-next-line consistent-return
            return (
              <LevelSelector component={component} {...this.props} urls={urls} perfMarker={this.props.perfMarker.createChild('adgroup_scope_page')} />
            );
          }}
        />
      </Switch>
    );
  }
};
